import { uuid } from 'vue-uuid';

/**
 * @typedef {import('bootstrap-vue/esm/components/toast').BvToastOptions} BvToastOptions
 */

/**
 * Muestra un toast en la aplicación.
 * @param {Vue} instance - La instancia de Vue.
 * @param {string} message - El mensaje a mostrar en el toast.
 * @param {BvToastOptions} options - Opciones adicionales para el toast.
 * @param {string} title - El título del toast.
 * @returns {{closeToast: () => void}} - Un objeto con una función `close` para cerrar el toast.
 */

export const showToast = (instance, message, title, options = {}) => {
  const id = uuid.v1();

  instance.$bvToast.toast(message, {
    id,
    title,
    variant: 'primary',
    pauseOnHover: true,
    solid: true,
    autoHideDelay: 4000,
    ...options,
  });

  return {
    closeToast: () => {
      instance.$bvToast.hide(id);
    },
  };
};
